"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorCodeFilterDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const shared_1 = require("../shared");
const boolean_transform_1 = require("../../constants/boolean.transform");
class BehaviorCodeFilterDto extends shared_1.PaginationOptionsDto {
    constructor(behaviorCodeFilterOptions) {
        super();
        if (!behaviorCodeFilterOptions)
            return;
        this.code = behaviorCodeFilterOptions.code;
        this.description = behaviorCodeFilterOptions.description;
        this.passMessage = behaviorCodeFilterOptions.passMessage;
        this.printPass = behaviorCodeFilterOptions.printPass;
        this.notificationTrigger = behaviorCodeFilterOptions.notificationTrigger;
        this.active = behaviorCodeFilterOptions.active;
        this.behaviorCodeTypeId = behaviorCodeFilterOptions.behaviorCodeTypeId;
        this.behaviorDistrictCodeId = behaviorCodeFilterOptions.behaviorDistrictCodeId;
        this.fastTrack = behaviorCodeFilterOptions.fastTrack;
        this.schoolId = behaviorCodeFilterOptions.schoolId;
        this.search = behaviorCodeFilterOptions.search;
    }
    code;
    description;
    search;
    passMessage;
    printPass;
    notificationTrigger;
    active;
    behaviorCodeTypeId;
    behaviorDistrictCodeId;
    fastTrack;
    schoolId;
}
exports.BehaviorCodeFilterDto = BehaviorCodeFilterDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], BehaviorCodeFilterDto.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], BehaviorCodeFilterDto.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], BehaviorCodeFilterDto.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], BehaviorCodeFilterDto.prototype, "passMessage", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], BehaviorCodeFilterDto.prototype, "printPass", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], BehaviorCodeFilterDto.prototype, "notificationTrigger", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], BehaviorCodeFilterDto.prototype, "active", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], BehaviorCodeFilterDto.prototype, "behaviorCodeTypeId", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], BehaviorCodeFilterDto.prototype, "behaviorDistrictCodeId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], BehaviorCodeFilterDto.prototype, "fastTrack", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], BehaviorCodeFilterDto.prototype, "schoolId", void 0);
